export default "__VITE_ASSET__BDh_Hk_B__"